import { EventBus } from '@/helpers/event-bus.js';
import { MessageType } from '@/models/enums';
import store from '@/store/store';
import { actions } from '@/models/store.actions';

const messageColorsMap = {
  [MessageType[MessageType.Success]]: 'success',
  [MessageType[MessageType.Warning]]: 'warning',
  [MessageType[MessageType.Error]]: 'error',
  [MessageType[MessageType.Info]]: 'accent'
};

const messageTimeoutMap = {
  [MessageType[MessageType.Success]]: 5000,
  [MessageType[MessageType.Warning]]: 10000,
  [MessageType[MessageType.Error]]: -1,
  [MessageType[MessageType.Info]]: 10000
};

export interface IMessage {
  message?: any;
  storeMessageId?: string;
  showTime?: number;
  windowColor?: string;
}

class MessageService {
  get isShowMessageAllowed(): boolean {
    return store.getters[actions.SETTTEMP_GET_ISSHOWMSG];
  }

  success(msg: IMessage) { this.emitShowMessage(MessageType.Success, msg); }

  info(msg: IMessage) { this.emitShowMessage(MessageType.Info, msg); }

  warn(msg: IMessage) { this.emitShowMessage(MessageType.Warning, msg); }

  error(msg: IMessage) { this.emitShowMessage(MessageType.Error, msg); }

  display(messageType: MessageType, msg: IMessage) { this.emitShowMessage(messageType, msg); }

  private emitShowMessage(
    type: MessageType,
    msg: IMessage) {
    if (msg && this.isShowMessageAllowed) {
      const timeout = this.getMessageShowTime(type, msg.showTime);
      const color = this.getMessageColor(type, msg.windowColor);

      EventBus.$emit('show-message', {
        message: msg.message || '',
        color,
        timeout,
        messageId: msg.storeMessageId
      });
    }
  }

  private getMessageShowTime(type: MessageType, incShowTime?: number): number {
    let showTime;
    if (incShowTime === undefined || incShowTime === null || isNaN(+incShowTime)) {
      showTime = messageTimeoutMap[MessageType[type]];
    } else {
      showTime = incShowTime;
    }
    return showTime;
  }

  private getMessageColor(type: MessageType, incColor?: string): string {
    let color;
    if (incColor) {
      color = incColor;
    } else {
      color = messageColorsMap[MessageType[type]];
    }
    return color;
  }
}

export const messageService = new MessageService();
